'use client'; // Error boundaries must be Client Components

// import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { inter } from '@/app/fonts';
import { Button } from '@/components/catalyst/button';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    // Sentry.captureException(error);
  }, [error]);

  return (
    // global-error must include html and body tags
    <html>
      <body className={`${inter.className} antialiased`}>
        <h2>Something went wrong</h2>
        <div className='my-3 font-bold'>
          There was a problem accessing that resource.
        </div>
        <Button onClick={() => reset()}>Try again</Button>
      </body>
    </html>
  );
}
